import React from 'react';
import './index.css';

function Article() {
  return (
    <div className='seguridad2'>
      <h3>Consejos de Seguridad</h3>
      <h4>Es muy importante recordar que el Banco nunca solicita datos personales o claves de acceso mediante correo electrónico o llamadas telefónicas.</h4>
      <div className="videos-grid">
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/v0tBsorCoyQ?si=fAbOCKnXXeF2pyA-" title="Fraudes por redes sociales" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>Fraudes por redes sociales</h5>
        </div>
        <div className="embed-container">
          <div className='embed-responsive embed-responsive-16by9 with-curves'>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/eTuA2WDk0cM?si=fAbOCKnXXeF2pyA-" title="Fraudes por mails" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <h5>Fraudes por mails</h5>
        </div>
      </div>
    </div>
  );
}

export default Article;
